<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Vector">
      <path
        d="M19.4358 0.565895C18.875 0.00498417 18.0424 -0.153374 17.3148 0.16251L5.39472 5.34404C4.68716 5.65158 4.25128 6.34834 4.28463 7.11928C4.31797 7.89023 4.81218 8.54698 5.54389 8.79201L9.7885 10.2139L11.2103 14.4587C11.4553 15.1905 12.112 15.6847 12.8829 15.7181C12.9104 15.7189 12.9379 15.7197 12.9654 15.7197C13.703 15.7197 14.3614 15.2905 14.6581 14.6079L19.8393 2.68711C20.1552 1.9595 19.9975 1.12681 19.4358 0.565895ZM18.6158 2.15528L13.4354 14.0761C13.3045 14.3778 13.0237 14.3886 12.9412 14.3853C12.8578 14.382 12.5795 14.3453 12.4753 14.0344L11.0794 9.86638L14.1747 6.7709C14.4347 6.51086 14.4347 6.08831 14.1747 5.82826C13.9146 5.56822 13.4921 5.56822 13.2321 5.82826L10.1368 8.92374L5.96897 7.5277C5.65729 7.42352 5.62144 7.14431 5.61811 7.0618C5.61478 6.97929 5.62645 6.69842 5.9273 6.56757L17.8466 1.38604C18.1849 1.23935 18.4266 1.44272 18.4933 1.50856C18.5591 1.5744 18.7633 1.81608 18.6158 2.15528Z"
        fill="#5CB85C"
      />
      <path
        d="M8.70152 11.3008C8.44148 11.0407 8.01897 11.0407 7.75893 11.3008L0.195024 18.8643C-0.0650079 19.1243 -0.0650079 19.5469 0.195024 19.8069C0.325035 19.9369 0.49589 20.002 0.66672 20.002C0.837549 20.002 1.00842 19.9369 1.13842 19.8069L8.70147 12.2434C8.9615 11.9834 8.96155 11.5608 8.70152 11.3008Z"
        fill="#5CB85C"
      />
      <path
        d="M8.17902 14.8021L4.73213 18.2492C4.4721 18.5092 4.4721 18.9318 4.73213 19.1918C4.86214 19.3218 5.033 19.3868 5.20383 19.3868C5.37466 19.3868 5.54553 19.3218 5.67552 19.1918L9.12241 15.7447C9.38245 15.4847 9.38245 15.0621 9.12241 14.8021C8.86238 14.542 8.43986 14.542 8.17983 14.8021H8.17902Z"
        fill="#5CB85C"
      />
      <path
        d="M1.28179 15.4654C1.45263 15.4654 1.62349 15.4004 1.75348 15.2704L5.20037 11.8233C5.4604 11.5632 5.4604 11.1407 5.20037 10.8807C4.94034 10.6206 4.51782 10.6206 4.25779 10.8807L0.810902 14.3277C0.550871 14.5878 0.550871 15.0103 0.810902 15.2704C0.940913 15.4004 1.11177 15.4654 1.2826 15.4654H1.28179Z"
        fill="#5CB85C"
      />
    </g>
  </svg>
</template>